var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { attrs: { action: _vm.action, method: "POST", target: "_blank" } },
    [
      _vm._l(_vm.fields, function (field) {
        return _c("input", {
          key: field.name,
          attrs: { type: "hidden", name: field.name },
          domProps: { value: field.value },
        })
      }),
      _c("c-button", {
        attrs: {
          type: "submit",
          icon: {
            icon: "google",
            color: "green",
          },
          label: "Выгрузить в Google таблицы",
          responsive: "",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }